import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Sparkles, Lock, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function Contest() {
  const [editions, setEditions] = useState([]);

  useEffect(() => {
    api.get("/editions").then((r) => setEditions(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <section className="bg-cc-navy text-white py-14 relative overflow-hidden grain">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <span className="eyebrow text-cc-gold">Nos Éditions</span>
          <h1 className="font-display text-5xl sm:text-6xl mt-3">LES JEUX CONCOURS COCARDE</h1>
          <p className="text-white/70 mt-4 max-w-xl mx-auto">Chaque série de boîtes a son édition et son jeu concours. Choisissez une édition pour découvrir ses candidats et participer.</p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="eyebrow text-cc-red flex items-center gap-2 justify-center"><Sparkles size={14} /> Les éditions</span>
          <h2 className="font-display text-4xl sm:text-5xl cc-navy mt-2">CHAQUE SÉRIE, SON JEU CONCOURS</h2>
          <p className="text-slate-500 mt-2">Élections, coupe du monde féminine, coupe de France… Chaque grand rendez-vous a son édition et ses boîtes collector. Les candidats sont visibles à l'intérieur de chaque édition.</p>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {editions.map((ed, i) => (
            <Link key={ed.slug} to={`/concours/${ed.slug}`} data-testid={`edition-card-${ed.slug}`}
              className="group rounded-3xl p-8 text-white relative overflow-hidden transition-transform hover:-translate-y-1"
              style={{ background: i % 2 === 0 ? "linear-gradient(120deg,#091E42,#1D4ED8)" : "linear-gradient(120deg,#7f1020,#E11D48)" }}>
              <div className="flex items-center justify-between gap-2">
                <span className="eyebrow text-cc-gold flex items-center gap-2"><Sparkles size={14} /> Édition</span>
                <span data-testid={`edition-card-status-${ed.slug}`} className={`text-xs font-bold rounded-full px-3 py-1 ${ed.status === "closed" ? "bg-white/20 text-white" : ed.status === "upcoming" ? "bg-cc-gold text-cc-navy" : "bg-green-400 text-cc-navy"}`}>
                  {ed.status === "closed" ? "Clôturée" : ed.status === "upcoming" ? "À venir" : "En cours"}
                </span>
              </div>
              <h3 className="font-display text-3xl sm:text-4xl mt-2">{ed.name.toUpperCase()}</h3>
              <p className="text-white/80 mt-2 text-sm">{ed.boxes.map((b) => b.name).join(" · ")}</p>
              <div className="flex items-center justify-between mt-6">
                <span className="inline-flex items-center gap-2 bg-white/15 rounded-full px-3 py-1.5 text-sm font-bold">
                  <Trophy size={15} className="text-cc-gold" /> {ed.candidate_count} candidat{ed.candidate_count > 1 ? "s" : ""}
                </span>
                <span className="inline-flex items-center gap-1 font-bold text-cc-gold group-hover:gap-2 transition-all">
                  {ed.status === "closed" ? "Voir le classement final" : "Entrer dans l'édition"} <ArrowRight size={18} />
                </span>
              </div>
            </Link>
          ))}
          {editions.length === 0 && (
            <div className="rounded-3xl p-8 bg-slate-100 flex flex-col justify-center md:col-span-2">
              <span className="eyebrow text-slate-400 flex items-center gap-2"><Lock size={13} /> Bientôt</span>
              <h3 className="font-display text-3xl cc-navy mt-2">Nos prochaines éditions</h3>
              <p className="text-slate-500 mt-2 text-sm">De nouvelles séries de boîtes arrivent pour chaque grand rendez-vous d'actu.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
